import { styled } from '@mui/material/styles';
import { Box, Typography, Button, InputBase } from '@mui/material';

const COLORS = {
  primary: '#4AB3BC',
  primaryDark: '#3E9FA7',
  primaryBg: '#F3F9FA',
  white: '#FFFFFF',
  gray1: '#F2F2F2',
  gray2: '#D9D9D9',
  gray4: '#A6A6A6',
  gray6: '#737373',
  gray8: '#404040',
  gray9: '#262626',
};

export const PickerContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column',
  width: '560px',
  maxWidth: 'calc(100vw - 32px)',
  maxHeight: 'calc(100vh - 80px)',
  backgroundColor: COLORS.white,
  borderRadius: '16px',
  outline: 'none',
  padding: '28px 28px 20px',
  boxShadow: '0 12px 32px rgba(20, 20, 20, 0.16)',
});

export const PickerCloseIcon = styled(Box)({
  position: 'absolute',
  top: '16px',
  right: '16px',
  width: '22px',
  height: '22px',
  cursor: 'pointer',
  color: COLORS.gray4,
  '&:hover': {
    color: COLORS.gray8,
  },
});

export const PickerHeader = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  marginBottom: '18px',
});

export const PickerTitle = styled(Typography)({
  fontSize: '17px',
  fontWeight: 700,
  color: COLORS.gray9,
});

export const PickerSubText = styled(Typography)({
  fontSize: '13px',
  lineHeight: 1.6,
  color: COLORS.gray6,
  wordBreak: 'keep-all',
});

export const PickerSearchRow = styled(Box)({
  display: 'flex',
  gap: '8px',
  marginBottom: '14px',
});

export const PickerSearchInput = styled(InputBase)({
  flex: 1,
  height: '42px',
  padding: '0 14px',
  fontSize: '14px',
  borderRadius: '8px',
  border: `1px solid ${COLORS.gray2}`,
  '&.Mui-focused': {
    borderColor: COLORS.primary,
  },
});

export const PickerSearchButton = styled(Button)({
  display: 'flex',
  gap: '4px',
  height: '42px',
  minWidth: '84px',
  background: COLORS.primary,
  color: COLORS.white,
  fontSize: '14px',
  fontWeight: 600,
  borderRadius: '8px',
  '&:hover': {
    background: COLORS.primaryDark,
  },
});

export const PickerListWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  overflowY: 'auto',
  minHeight: '220px',
  maxHeight: '380px',
  paddingRight: '4px',
});

export const PickerRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  padding: '12px 14px',
  borderRadius: '8px',
  border: `1px solid ${COLORS.gray1}`,
  cursor: 'pointer',
  transition: 'background 0.15s, border-color 0.15s',
  '&:hover': {
    background: COLORS.primaryBg,
    borderColor: COLORS.primary,
  },
});

export const PickerRowMain = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '3px',
  minWidth: 0,
});

export const PickerRowName = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: COLORS.gray9,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const PickerRowMeta = styled(Typography)({
  fontSize: '12px',
  color: COLORS.gray6,
});

export const PickerRowPrice = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: COLORS.gray8,
  whiteSpace: 'nowrap',
});

export const PickerEmpty = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '200px',
  fontSize: '14px',
  color: COLORS.gray4,
});

export const PickerMoreButton = styled(Button)({
  marginTop: '4px',
  height: '38px',
  fontSize: '13px',
  fontWeight: 600,
  color: COLORS.gray6,
  background: COLORS.gray1,
  borderRadius: '8px',
  '&:hover': {
    background: COLORS.gray2,
  },
});
